import React, { useState, useEffect } from "react";
import "./Loader.css";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminDashboard from "./admindashboard";
import SecretKeyDecryption from "./secretKeyDecryption";
import { passwordEncrypt } from "./passwordEncryption"; 
import "./hm-theme.css";

function ViewAdminProfileBySuper() {
  const { userid } = useParams();
  const { fetchSecretKey } = SecretKeyDecryption();

  const url = `/api/user/profile/userid=${userid}`;

  const [password, setPassword] = useState('');
  const token = JSON.parse(localStorage.getItem("data"))?.token;

  const [profile, setProfile] = useState({
    userId: "",
    name: "",
    lastname: "",
    phone: "",
    email: "",
    company: "",
    country: "",
    image: null,
    imageMeta: "",
    firstname: "",
    dob: "",
    orgProfile: {
      officeLatitude: "",
      officeLongitude: "",
      godownLatitude: "",
      godownLongitude: "",  
      orgcode: JSON.parse(localStorage.getItem("data"))?.orgcode || "" 
    }
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        const [metadata, content] = reader.result.split(",");
        resolve({ metadata, content });
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  const handleImageChange = async (event) => {
    if (event.target.files && event.target.files[0]) {
      const convertedImage = await getBase64FromFile(event.target.files[0]);
      const imageObject = {
        ...profile,
        imageMeta: convertedImage.metadata,
        image: convertedImage.content,
      };
      setProfile(imageObject);
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProfile(data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const decryptedSecretKey = await fetchSecretKey();
      if (!decryptedSecretKey) {
        setLoading(false);
        return;
      }
      const encryptedPassword = await passwordEncrypt(password, decryptedSecretKey);
      const body = {
        id: userid,
        password: encryptedPassword,
      };

      await axios.post(`/api/accounts/update-password`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Password Updated Successfully");
      setPassword("");
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const handleChange = (event, field) => {
    if (profile.orgProfile && field in profile.orgProfile) {
      setProfile({
        ...profile,
        orgProfile: { ...profile.orgProfile, [field]: event.target.value },
      });
    } else {
      setProfile({ ...profile, [field]: event.target.value });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post("/api/user/profile/update", profile, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      localStorage.setItem("profile", JSON.stringify(response.data));
      toast.success("Profile Updated");
      navigate("/users/adminprofile");
    } catch (error) {
      setLoading(false);
      if (error.response?.status === 401 || error.response?.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error("something went wrong on server !!");
      }
    }
  };

  return (
    <div>
      <div>
        <AdminDashboard />
      </div>    
      {loading && <div className="loading"></div>} 
    
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">account_circle</i>
                Admin Profile Details
              </h2>
              <p className="hm-page-subtitle">
                View and update admin profile information and update account password.
              </p>
            </div>
          </div>

          {/* Profile Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">badge</i>
                Personal Details
              </h3>
            </div>
            <div className="hm-card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="row g-4 align-items-center mb-4 pb-3 border-bottom">
                  <div className="col-auto text-center">
                    {profile.image ? (
                      <img
                        className="img-fluid rounded-circle border shadow-sm mb-2"
                        id="image"
                        src={`${profile?.imageMeta},${profile?.image}`}
                        alt="User Profile"
                        style={{
                          width: "130px",
                          height: "130px",
                          objectFit: "cover",
                          display: "block"
                        }}
                      />
                    ) : (
                      <div
                        className="d-flex align-items-center justify-content-center rounded-circle border shadow-sm mb-2 mx-auto"
                        style={{
                          width: "130px",
                          height: "130px",
                          background: "rgba(47, 58, 136, 0.1)",
                          color: "#2f3a88"
                        }}
                      >
                        <i className="material-icons" style={{ fontSize: "3.5rem" }}>person</i>
                      </div>
                    )}
                    <div>
                      <label className="btn btn-outline-primary btn-sm rounded-pill cursor-pointer m-0">
                        <i className="material-icons align-middle me-1" style={{ fontSize: "1rem" }}>photo_camera</i>
                        Upload Photo
                        <input
                          type="file"
                          className="d-none"
                          onChange={(event) => handleImageChange(event)}
                          accept="image/*"
                        />
                      </label>
                    </div>
                  </div>
                  <div className="col">
                    <h4 className="fw-bold mb-1" style={{ color: "#1e293b" }}>
                      {profile.name || "Admin User"}
                    </h4>
                    <p className="text-muted small mb-0">{profile.email}</p>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="name" className="form-label small fw-semibold">Name :</label>
                    <input
                      className="form-control"
                      id="name"
                      type="text"
                      value={profile.name || ""}
                      onChange={(e) => handleChange(e, "name")}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="phone" className="form-label small fw-semibold">Phone Number :</label>
                    <input
                      className="form-control"
                      id="phone"
                      type="text"
                      value={profile.phone || ""}
                      onChange={(e) => {
                        const inputText = e.target.value.replace(/\D/g, '');
                        const limitedText = inputText.slice(0, 10);
                        setProfile({ ...profile, phone: limitedText });
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="email" className="form-label small fw-semibold">Email ID :</label>
                    <input
                      className="form-control bg-light"
                      id="email"
                      type="email"
                      value={profile.email || ""}
                      readOnly
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="dob" className="form-label small fw-semibold">Date Of Birth :</label>
                    <input
                      className="form-control"
                      id="dob"
                      type="date"
                      value={profile.dob || ""}
                      onChange={(e) => handleChange(e, "dob")}
                    />
                  </div>
                </div>

                <div className="mt-4 pt-2">
                  <button type="submit" className="btn-hm-primary px-4">
                    <i className="material-icons me-1" style={{ fontSize: "1rem" }}>save</i>
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Update Password Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">lock</i>
                Update Password
              </h3>
            </div>
            <div className="hm-card-body p-4">
              <form onSubmit={handlePasswordSubmit}>
                <div className="row align-items-end g-3">
                  <div className="col-md-6">
                    <label htmlFor="password" className="form-label small fw-semibold">Password :</label>
                    <input
                      className="form-control"
                      id="password"
                      type="password"
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="col-md-auto">
                    <button type="submit" className="btn-hm-primary px-4">
                      <i className="material-icons me-1" style={{ fontSize: "1rem" }}>key</i>
                      Update Password
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewAdminProfileBySuper;

